import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect
} from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS, CARD_BRANDS } from "consts";
import { ReactComponent as QuestionMarkIcon } from "assets/images/app_svg/questionMark.svg";

const BillingInfo = forwardRef((props, ref) => {
  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        lineHeight: "1.4em",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    },
    disabled: false,
    //disabling autofill link from stripe
    disableLink: true,
    hidePostalCode: true
  };

  const stripe = useStripe();
  const elements = useElements();
  const [billing, setBilling] = useState({ bill: "", zip: "" });

  function handleBilling(e, type, value) {
    props.setCardError(prevState => ({
      ...prevState,
      [type]: { show: false, msg: "" }
    }));
    if (
      (type === "bill" && value.length > 50) ||
      (type === "zip" && value.length > 10)
    )
      setBilling(prevState => prevState);
    else
      setBilling(prevState => ({
        ...prevState,
        [type]: value.replace(/^\s+/g, "")
      }));

    if (e.type === "blur" && e.relatedTarget !== null && value === "") {
      if (type === "bill")
        props.setCardError(prevState => ({
          ...prevState,
          bill: {
            show: true,
            msg: "Billing address cannot be blank"
          }
        }));
      else
        props.setCardError(prevState => ({
          ...prevState,
          zip: { show: true, msg: "zip code cannot be blank" }
        }));
    }
  }

  useImperativeHandle(ref, () => ({
    async handleSubmit(event) {
      // We don't want to let default form submission happen here,
      // which would refresh the page.
      event.preventDefault();

      if (!stripe || !elements) {
        // Stripe.js has not yet loaded.
        // Make  sure to disable form submission until Stripe.js has loaded.
        return;
      }

      let result = {};
      if (props.ccDetails === undefined || props.newCard) {
        const card = elements.getElement(CardElement);
        const data = { address_line1: billing.bill, address_zip: billing.zip };
        result = await stripe.createToken(card, data);
      }

      return { ...result, ...{ bill: billing.bill, zip: billing.zip } };
    }
  }));

  useEffect(() => {
    if (props.ccDetails)
      setBilling({ bill: props.ccDetails.address, zip: props.ccDetails.zip });
    // else if (props.ccUpdate) {
    //   setBilling({ bill: "", zip: "" });
    // }

    if (props.newCard) {
      setBilling({ bill: "", zip: "" });
    }
  }, [props.ccDetails, props.newCard]);

  // function newCardSet(bool){
  //   setNewCard(bool);
  //   setBilling({ bill: "", zip: "" });
  // }

  let content = "";
  if (props.type === "layout") {
    content = (
      <React.Fragment>
        <div className="common_txtBox_row credit_card_field">
          <label>
            Card Number, expiry date and CVC
            <Tooltip {...TOOLTIPS.account.cardCC}>
              <font className="svg_wrap tooltip_span">
                <QuestionMarkIcon />
              </font>
            </Tooltip>
          </label>
          {props.ccDetails && props.ccDetails && !props.newCard ? (
            <div className="customCreditCard_wrap">
              <div className="customCreditCard">
                <div
                  className={`card_num ${
                    CARD_BRANDS[props.ccDetails.cardType]
                      ? CARD_BRANDS[props.ccDetails.cardType]
                      : "no_card"
                  }`}
                >
                  ************{props.ccDetails.cardNumber}
                </div>
                <div className="expiry_num">
                  <span id="read_exp_month">
                    {props.ccDetails.cardExp.split("/")[0]}
                  </span>
                  &nbsp;/&nbsp;
                  <span id="read_exp_year">
                    {props.ccDetails.cardExp.split("/")[1]}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <CardElement
              options={CARD_ELEMENT_OPTIONS}
              onChange={() =>
                props.setCardError(prevState => ({
                  ...prevState,
                  card: { show: false, msg: "" }
                }))
              }
              onReady={e => e.focus()}
            />
          )}
          {props.error.card.show && (
            <span class="error-msg">{props.error.card.msg}</span>
          )}{" "}
        </div>

        <div className="field_wrap field_wrap_col1 field_border_btm">
          <div className="fw_row1">
            <div className="common_txtBox_row">
              <label>Billing address</label>
              <input
                type="text"
                name="billingAddress"
                id="billingAddress"
                className="input_text"
                onChange={e => handleBilling(e, "bill", e.target.value)}
                onBlur={e => handleBilling(e, "bill", e.target.value)}
                value={billing.bill}
              />
              {props.error.bill.show && (
                <span class="error-msg">{props.error.bill.msg}</span>
              )}
            </div>
            <div className="common_txtBox_row">
              <label>Zip code</label>
              <input
                type="text"
                name="zipCode"
                id="zipCode"
                className="input_text"
                onChange={e => handleBilling(e, "zip", e.target.value)}
                onBlur={e => handleBilling(e, "zip", e.target.value)}
                value={billing.zip}
              />
              {props.error.zip.show && (
                <span class="error-msg">{props.error.zip.msg}</span>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  } else if (props.type !== "promoRegister") {
    content = (
      <div className="credit_card_form">
        <h3 className="title">
          {props.type === "register" ? (
            "Billing Information"
          ) : props.ccDetails && !props.newCard ? (
            <div className="title">
              Payment Information (
              <a className="j_update_credit_card">
                <span
                  className="pts__title"
                  onClick={() => {
                    props.setNewCard(true);
                    props.setCardError({
                      card: { show: false, msg: "" },
                      bill: { show: false, msg: "" },
                      zip: { show: false, msg: "" }
                    });
                  }}
                >
                  {" "}
                  Add New Card{" "}
                </span>
              </a>
              )
            </div>
          ) : (
            "Payment Information"
          )}
        </h3>
        <div className="msg_notification">
          <div className="msgErrorcom" style={{ display: "block" }}></div>
        </div>
        {/* <div className="update_account_tabs">
        <ul className="flex_align_center"> */}
        {/* <li className="ccard_method" data-account="plan_allcards">
            <label className="radio_container flex_align_center">
              <input
                type="radio"
                className="input_radio"
                name="plan_options"
                defaultChecked
              />
              <span className="radio_checkmark" />{" "}
              <img
                src={
                  process.env.REACT_APP_STATIC_URL + "/images/allcards_new.png"
                }
                alt="paypal"
              />{" "}
            </label>
          </li> */}
        {/* <li className="paypal_method" data-account="plan_acc_details">
            <label className="radio_container flex_align_center">
              <input type="radio" className="input_radio" name="plan_options" />
              <span className="radio_checkmark" />{" "}
              <img
                src={process.env.REACT_APP_STATIC_URL + "/images/pp_paypal.png"}
                alt="Paypal"
              />
            </label>
          </li> */}
        {/* </ul>
      </div> */}
        <div
          className={
            props.type === "register"
              ? "plan_allcards"
              : props.type === "update"
              ? "update_credit_card_wrap"
              : "stripe_credit_card"
          }
          style={{}}
        >
          {/* <div className={["credit_card_details", props.type==="register"?"d_flex":""].join(" ")}>
        <div className="ccd_item card_number">
          <div className="ccd_label">
            <label>Card Number</label>
          </div>
          <div className="input_field_msg">
            <div>
              <CardNumberElement options={CARD_NUMBER_ELEMENT_OPTIONS} onFocus={()=>props.setCCUpdate?props.setCCUpdate(true):undefined}/>
            </div>
            {props.error.show === "card" && (
          <span className="error-msg" style={{ display: "block" }}>
            {props.error.msg}
          </span>
        )}
            <div className="all_card_holder" />
          </div>
        </div>
        <div className="ccd_item cvv">
          <div className="ccd_label just_flex">
            <label>CVV</label>
            <div className="icon" data-toggle="tooltip" data-original-title="For Visa, MasterCard, and Discover cards, the CVV is the last 3 digit number printed on the back of the card on the signature panel, immediately after the card number. For an American Express card, it is the 4 digit number printed on the front of the card, above the card number." />
          </div>
          <div className="input_field_msg">
            <div>
            
            <CardCvcElement options={CARD_CVC_ELEMENT_OPTIONS} onFocus={()=>props.setCCUpdate?props.setCCUpdate(true):undefined}/>
            </div>
          </div>
        </div>
        <div className="ccd_item expiry_date">
          <div className="ccd_label">
            <label>Expiry Date</label>
          </div>
          <div className="ccd_grp just_flex">
          <div style={{width:"100px"}}><CardExpiryElement options={CARD_EXPIRY_ELEMENT_OPTIONS} onFocus={()=>props.setCCUpdate?props.setCCUpdate(true):undefined}/></div>
            </div>
          </div>
          
      </div> */}
          {props.ccDetails && props.ccDetails && !props.newCard ? (
            <div className="saved_card_form">
              <div className="plan_allcards">
                <div className="credit_card_details d_flex">
                  {" "}
                  <div className="ccd_item card_number">
                    <div className="ccd_label">
                      <span>Card number, expiry date and CVC</span>{" "}
                      <Tooltip {...TOOLTIPS.account.cardCC}>
                        <span className="icon"></span>
                      </Tooltip>
                    </div>
                    <div className="input_field_msg stripe_field_msg">
                      <div>
                        <div
                          className="modalRow newcard"
                          id="upgrade_existing_cc"
                        >
                          <p
                            className={`cardNumber ${
                              CARD_BRANDS[props.ccDetails.cardType]
                                ? CARD_BRANDS[props.ccDetails.cardType]
                                : "no_card"
                            }`}
                            id="read_ccno"
                          >
                            ************{props.ccDetails.cardNumber}
                          </p>
                          <p className="expirydate">
                            <span id="read_exp_month">
                              {props.ccDetails.cardExp.split("/")[0]}
                            </span>
                            /
                            <span id="read_exp_year">
                              {props.ccDetails.cardExp.split("/")[1]}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className={[
                "credit_card_details",
                props.type === "register" ? "" : "d_flex"
              ].join(" ")}
            >
              <div className="ccd_item card_number">
                <div className="ccd_label">
                  <span>Card number, expiry date and CVC</span>{" "}
                  <Tooltip {...TOOLTIPS.account.cardCC}>
                    <span className="icon"></span>
                  </Tooltip>
                </div>
                {/* <label for="card-element">
            Card number, expiry date and CVC
            <span
              className="icon"
              data-toggle="tooltip"
              title=""
              data-original-title="For Visa, MasterCard, and Discover cards, the CVV is the last 3 digit number located on the back of your card on or above your signature line. For an American Express card, it is the 4 digits on the FRONT above the end of your card number."
            ></span>
            <br /> */}
                <div className="stripe-card-wrap">
                  <CardElement
                    options={CARD_ELEMENT_OPTIONS}
                    onChange={() =>
                      props.setCardError(prevState => ({
                        ...prevState,
                        card: { show: false, msg: "" }
                      }))
                    }
                    onReady={e => e.focus()}
                  />
                </div>
              </div>
              {props.type === "register" && props.error.card.show && (
                <span className="error-msg" style={{ display: "block" }}>
                  {props.error.card.msg}
                </span>
              )}{" "}
            </div>
          )}
          {props.type !== "register" && props.error.card.show && (
            <span className="error-msg" style={{ display: "block" }}>
              {props.error.card.msg}
            </span>
          )}{" "}
          <div className="input_group">
            <div className="input_field_msg">
              <div className="input_billing">
                <label>Billing Address</label>
                <input
                  type="text"
                  className="input_text"
                  onChange={e => handleBilling(e, "bill", e.target.value)}
                  onBlur={e => handleBilling(e, "bill", e.target.value)}
                  value={billing.bill}
                />
              </div>
              {props.error.bill.show && (
                <span className="error-msg" style={{ display: "block" }}>
                  {props.error.bill.msg}
                </span>
              )}
            </div>
            <div className="input_field_msg">
              <div className="input_zip">
                <label>Zip Code</label>
                <input
                  type="text"
                  className="input_text"
                  name="input_text_zip_code"
                  onChange={e => handleBilling(e, "zip", e.target.value)}
                  onBlur={e => handleBilling(e, "zip", e.target.value)}
                  value={billing.zip}
                />
              </div>
              {props.error.zip.show && (
                <span className="error-msg" style={{ display: "block" }}>
                  {props.error.zip.msg}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    content = (
      <React.Fragment>
        <div className="subhead">Billing information</div>
        <div
          className="inp_row card_detail_field clearfix"
          id="card_detail_field"
        >
          <label>
            Card number, expiry date and CVC
            <Tooltip {...TOOLTIPS.account.cardCC}>
              <span className="svg_wrap">
                <QuestionMarkIcon />
              </span>
            </Tooltip>
          </label>
          <CardElement
            options={CARD_ELEMENT_OPTIONS}
            onChange={() =>
              props.setCardError(prevState => ({
                ...prevState,
                card: { show: false, msg: "" }
              }))
            }
          />
          {/* <div id="card-errors" role="alert" /> */}
          {props.error.card.show && (
            <span className="error-msg" style={{ display: "block" }}>
              {props.error.card.msg}
            </span>
          )}{" "}
        </div>
        <div className="inp_row clearfix">
          <div className="inp_col_lhs">
            <label>Billing Address</label>
            <input
              type="text"
              className="txt_box"
              onChange={e => handleBilling(e, "bill", e.target.value)}
              onBlur={e => handleBilling(e, "bill", e.target.value)}
              value={billing.bill}
            />
            {props.error.bill.show && (
              <span className="error-msg" style={{ display: "block" }}>
                {props.error.bill.msg}
              </span>
            )}
          </div>
          <div className="inp_col_rhs">
            <label>Zip Code</label>
            <input
              type="text"
              className="txt_box"
              onChange={e => handleBilling(e, "zip", e.target.value)}
              onBlur={e => handleBilling(e, "zip", e.target.value)}
              value={billing.zip}
            />
            {props.error.zip.show && (
              <span className="error-msg" style={{ display: "block" }}>
                {props.error.zip.msg}
              </span>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
  return content;
});

export default BillingInfo;
